import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../i18n/i18n';
import { useNavigate } from 'react-router-dom';

const LanguageSwitcher = ({ onSwitchLanguage }) => {
  const { language, changeLanguage, t } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);
  const rootRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!showDropdown) return;
    const onPointer = event => { if (!rootRef.current?.contains(event.target)) setShowDropdown(false); };
    const onKey = event => { if (event.key === 'Escape') setShowDropdown(false); };
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('pointerdown', onPointer); document.removeEventListener('keydown', onKey); };
  }, [showDropdown]);

  const handleSwitch = (lang) => {
    changeLanguage(lang);
    if (onSwitchLanguage) {
      onSwitchLanguage(lang);
    } else {
      // 如果没有提供自定义回调，则使用默认导航行为
      if (lang === 'en') {
        navigate('/');
      } else {
        navigate(`/${lang}`);
      }
    }
    setShowDropdown(false);
  };

  // 语言配置
  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
    { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'th', name: 'ไทย', flag: '🇹🇭' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' }
  ];

  // 查找当前语言
  const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

  return (
    <div className="language-switcher" ref={rootRef}>
      <button 
        className="current-language"
        onClick={() => setShowDropdown(!showDropdown)}
        aria-label="Select language"
        aria-haspopup="true"
        aria-expanded={showDropdown}
      >
        <i className="fas fa-globe-americas" style={{marginRight: '5px', fontSize: '16px'}}></i>
        <span className="lang-name">{currentLanguage.name}</span>
        <span className="lang-flag" aria-hidden="true">{currentLanguage.flag}</span>
        <span className="dropdown-arrow">▼</span>
      </button>
      
      {showDropdown && (
        <div className="language-dropdown">
          <div className="dropdown-header">
            <i className="fas fa-language" style={{marginRight: '5px'}}></i>
            {t('selectLanguage') || 'Select Language'}
          </div>
          {languages.map(lang => (
            <button 
              key={lang.code}
              className={`lang-option ${language === lang.code ? 'active' : ''}`} 
              onClick={() => handleSwitch(lang.code)}
              title={lang.name}
              aria-label={`Switch to ${lang.name}`}
            >
              <span className="lang-flag" aria-hidden="true">{lang.flag}</span>
              <span className="lang-name">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
